import { IApplicable } from 'src/app/shared/models/applicable';
import { IBookmarkable } from 'src/app/shared/models/bookmarkable';
import { IMilestoneResponseDto } from '../../shared/models/responses/milestone.response';
import { environment } from 'src/environments/environment';

export class JobPreview implements IBookmarkable, IApplicable {

    constructor() {
    }

    public id: string;
    public title: string;
    public description: string;
    public expiry: string;
    public applicants: number;
    public views: number;
    public sector: string;
    public salaryType: string;
    public type: string;
    public salaryRange: string;
    public skills: string;
    public location: string;
    public city: string;
    public country: string;
    public education: string;
    public experience: string;
    public datePosted: Date;
    public bookmarked: boolean;
    public applied: boolean;
    public applicationDate: Date;
    public expired: boolean;
    public businessLogo: string;
    public jobMilestones: IMilestoneResponseDto[];
    public jobPoster: string;

    public static parse(json): JobPreview {
        let jobPreview = new JobPreview();
        Object.assign(jobPreview, json);

        if(jobPreview.expiry == "Expired") {
            jobPreview.expired = true;
        }

        jobPreview.businessLogo = `${environment.baseUrl}/${jobPreview.businessLogo}`;

        return jobPreview;
    }
}

